import { createSlice } from '@reduxjs/toolkit';

import zoomApi from 'api/zoomApi';
import { LIMIT_GET_LIST } from 'constants/constants';
import { INIT_DATA } from 'constants/default';

import { logout } from '../auth/index';

const initialState = {
  zooms: INIT_DATA,
  selectedZoom: undefined,
};

const zoomSlice = createSlice({
  name: 'zoom',
  initialState,
  reducers: {
    setZooms: (state, action) => {
      state.zooms = action.payload;
    },
    selectZoom: (state, action) => {
      state.selectedZoom = action.payload;
    },
  },
  extraReducers: {
    [logout]: () => initialState,
  },
});

export const { setZooms, selectZoom } = zoomSlice.actions;

export const getZooms = (state) => state.zoom.zooms;
export const getselectedZoom = (state) => state.zoom.selectedZoom;

export const getZoomsAsync = (params) => async (dispatch) => {
  const zooms = await zoomApi.getAll({
    ...params,
    rowPerPage: LIMIT_GET_LIST,
  });
  return dispatch(setZooms(zooms));
};

export default zoomSlice.reducer;
